(() => {
  const initGallery = (gallery) => {
    if (gallery.dataset.modelGalleryReady === 'true') return;

    const dialog = gallery.querySelector('[data-model-gallery-lightbox]');
    const triggers = Array.from(gallery.querySelectorAll('[data-model-gallery-trigger]'));
    const thumbnails = Array.from(gallery.querySelectorAll('[data-model-gallery-thumbnail]'));
    const mainImage = gallery.querySelector('[data-model-gallery-image]');
    const counter = gallery.querySelector('[data-model-gallery-counter]');
    const previous = gallery.querySelector('[data-model-gallery-previous]');
    const next = gallery.querySelector('[data-model-gallery-next]');
    const close = gallery.querySelector('[data-model-gallery-close]');
    const stage = gallery.querySelector('[data-model-gallery-stage]');

    if (!dialog || !mainImage || thumbnails.length === 0) return;

    gallery.dataset.modelGalleryReady = 'true';
    let currentIndex = 0;
    let lastActiveElement = null;
    let pointerStartX = null;

    const normalizeIndex = (index) => (index + thumbnails.length) % thumbnails.length;

    const preloadAdjacent = () => {
      if (thumbnails.length < 2) return;
      [-1, 1].forEach((offset) => {
        const preload = new Image();
        preload.src = thumbnails[normalizeIndex(currentIndex + offset)].dataset.fullSrc;
      });
    };

    const showImage = (index, focusThumbnail = false) => {
      currentIndex = normalizeIndex(index);
      const selected = thumbnails[currentIndex];

      mainImage.src = selected.dataset.fullSrc;
      mainImage.alt = selected.dataset.alt || '';
      counter.textContent = `${currentIndex + 1} / ${thumbnails.length}`;

      thumbnails.forEach((thumbnail, thumbnailIndex) => {
        if (thumbnailIndex === currentIndex) {
          thumbnail.setAttribute('aria-current', 'true');
        } else {
          thumbnail.removeAttribute('aria-current');
        }
      });

      selected.scrollIntoView({ block: 'nearest', inline: 'center' });
      if (focusThumbnail) selected.focus({ preventScroll: true });
      preloadAdjacent();
    };

    const openLightbox = (index, trigger) => {
      lastActiveElement = trigger;
      showImage(index);

      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }

      document.documentElement.classList.add('model-gallery-lightbox-open');
      close.focus({ preventScroll: true });
    };

    const closeLightbox = () => {
      if (typeof dialog.close === 'function' && dialog.open) {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
      }
    };

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        openLightbox(Number(trigger.dataset.index), trigger);
      });
    });

    thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => {
        showImage(Number(thumbnail.dataset.index), true);
      });
    });

    previous.addEventListener('click', () => showImage(currentIndex - 1));
    next.addEventListener('click', () => showImage(currentIndex + 1));
    close.addEventListener('click', closeLightbox);

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) closeLightbox();
    });

    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('model-gallery-lightbox-open');
      mainImage.removeAttribute('src');
      if (lastActiveElement) lastActiveElement.focus({ preventScroll: true });
    });

    dialog.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        showImage(currentIndex - 1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        showImage(currentIndex + 1);
      } else if (event.key === 'Home') {
        event.preventDefault();
        showImage(0, true);
      } else if (event.key === 'End') {
        event.preventDefault();
        showImage(thumbnails.length - 1, true);
      }
    });

    stage.addEventListener('pointerdown', (event) => {
      pointerStartX = event.clientX;
    });

    stage.addEventListener('pointerup', (event) => {
      if (pointerStartX === null) return;
      const distance = event.clientX - pointerStartX;
      pointerStartX = null;
      if (Math.abs(distance) < 50) return;
      showImage(currentIndex + (distance < 0 ? 1 : -1));
    });

    stage.addEventListener('pointercancel', () => {
      pointerStartX = null;
    });
  };

  const initAllGalleries = () => {
    document.querySelectorAll('[data-model-gallery]').forEach(initGallery);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllGalleries, { once: true });
  } else {
    initAllGalleries();
  }

  document.addEventListener('shopify:section:load', initAllGalleries);
})();


/* Keep the mobile gallery flush with both viewport edges, even inside an offset theme container. */
(() => {
  const alignGallery = (gallery) => {
    gallery.style.removeProperty('width');
    gallery.style.removeProperty('max-width');
    gallery.style.removeProperty('margin-left');

    if (!window.matchMedia('(max-width: 749px)').matches) return;

    gallery.style.setProperty('width', `${document.documentElement.clientWidth}px`, 'important');
    gallery.style.setProperty('max-width', 'none', 'important');
    gallery.style.setProperty('margin-left', `${-gallery.getBoundingClientRect().left}px`, 'important');
  };

  const alignAll = () => {
    document.querySelectorAll('[data-model-gallery]').forEach(alignGallery);
  };

  const scheduleAlignment = () => window.requestAnimationFrame(alignAll);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleAlignment, { once: true });
  } else {
    scheduleAlignment();
  }

  window.addEventListener('resize', scheduleAlignment, { passive: true });
  document.addEventListener('shopify:section:load', scheduleAlignment);
})();



/* Align the image grid itself to remove theme container and list offsets. */
(() => {
  const alignGrid = (gallery) => {
    const grid = gallery.querySelector('.product-model-gallery__grid');
    gallery.style.removeProperty('width');
    gallery.style.removeProperty('max-width');
    gallery.style.removeProperty('margin-left');
    if (!grid) return;

    grid.style.removeProperty('width');
    grid.style.removeProperty('max-width');
    grid.style.removeProperty('margin-left');

    if (!window.matchMedia('(max-width: 749px)').matches) return;

    grid.style.setProperty('width', `${document.documentElement.clientWidth}px`, 'important');
    grid.style.setProperty('max-width', 'none', 'important');
    grid.style.setProperty('margin-left', `${-grid.getBoundingClientRect().left}px`, 'important');
  };

  const alignAllGrids = () => document.querySelectorAll('[data-model-gallery]').forEach(alignGrid);
  const scheduleGridAlignment = () => window.requestAnimationFrame(alignAllGrids);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleGridAlignment, { once: true });
  } else {
    scheduleGridAlignment();
  }

  window.addEventListener('resize', scheduleGridAlignment, { passive: true });
  document.addEventListener('shopify:section:load', scheduleGridAlignment);
})();

/* Final rendered-position correction for asymmetric mobile theme containers. */
(() => {
  const correctResidualOffset = () => {
    window.requestAnimationFrame(() => {
      document.querySelectorAll('[data-model-gallery] .product-model-gallery__grid').forEach((grid) => {
        grid.style.removeProperty('transform');
        if (!window.matchMedia('(max-width: 749px)').matches) return;

        window.requestAnimationFrame(() => {
          const residualOffset = grid.getBoundingClientRect().left;
          grid.style.setProperty('transform', `translateX(${-residualOffset}px)`, 'important');
        });
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', correctResidualOffset, { once: true });
  } else {
    correctResidualOffset();
  }

  window.addEventListener('resize', correctResidualOffset, { passive: true });
  document.addEventListener('shopify:section:load', correctResidualOffset);
})();

/* Final rendered-position correction for asymmetric mobile theme containers. */
(() => {
  const correctResidualOffset = () => {
    window.requestAnimationFrame(() => {
      document.querySelectorAll('[data-model-gallery] .product-model-gallery__grid').forEach((grid) => {
        grid.style.removeProperty('transform');
        if (!window.matchMedia('(max-width: 749px)').matches) return;

        window.requestAnimationFrame(() => {
          const residualOffset = grid.getBoundingClientRect().left;
          grid.style.setProperty('transform', `translateX(${-residualOffset}px)`, 'important');
        });
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', correctResidualOffset, { once: true });
  } else {
    correctResidualOffset();
  }

  window.addEventListener('resize', correctResidualOffset, { passive: true });
  document.addEventListener('shopify:section:load', correctResidualOffset);
})();

/* Re-check mobile alignment after late theme and app layout changes. */
(() => {
  const stabilize = () => {
    document.querySelectorAll('[data-model-gallery] .product-model-gallery__grid').forEach((grid) => {
      if (!window.matchMedia('(max-width: 749px)').matches) {
        grid.style.removeProperty('transform');
        return;
      }

      const transform = window.getComputedStyle(grid).transform;
      const currentX = transform === 'none' ? 0 : new DOMMatrixReadOnly(transform).m41;
      const residualOffset = grid.getBoundingClientRect().left;
      grid.style.setProperty('transform', `translateX(${currentX - residualOffset}px)`, 'important');
    });
  };

  const schedule = () => window.requestAnimationFrame(stabilize);

  [0, 100, 300, 750, 1500, 3000, 6000, 10000].forEach((delay) => {
    window.setTimeout(schedule, delay);
  });

  window.addEventListener('load', schedule, { once: true });
  window.addEventListener('pageshow', schedule);
  window.addEventListener('resize', schedule, { passive: true });

  if ('ResizeObserver' in window) {
    const observer = new ResizeObserver(schedule);
    document.querySelectorAll('[data-model-gallery]').forEach((gallery) => {
      if (gallery.parentElement) observer.observe(gallery.parentElement);
    });
  }
})();

/* Re-check mobile alignment after late theme and app layout changes. */
(() => {
  const stabilize = () => {
    document.querySelectorAll('[data-model-gallery] .product-model-gallery__grid').forEach((grid) => {
      if (!window.matchMedia('(max-width: 749px)').matches) {
        grid.style.removeProperty('transform');
        return;
      }

      const transform = window.getComputedStyle(grid).transform;
      const currentX = transform === 'none' ? 0 : new DOMMatrixReadOnly(transform).m41;
      const residualOffset = grid.getBoundingClientRect().left;
      grid.style.setProperty('transform', `translateX(${currentX - residualOffset}px)`, 'important');
    });
  };

  const schedule = () => window.requestAnimationFrame(stabilize);

  [0, 100, 300, 750, 1500, 3000, 6000, 10000].forEach((delay) => {
    window.setTimeout(schedule, delay);
  });

  window.addEventListener('load', schedule, { once: true });
  window.addEventListener('pageshow', schedule);
  window.addEventListener('resize', schedule, { passive: true });

  if ('ResizeObserver' in window) {
    const observer = new ResizeObserver(schedule);
    document.querySelectorAll('[data-model-gallery]').forEach((gallery) => {
      if (gallery.parentElement) observer.observe(gallery.parentElement);
    });
  }
})();
